<template>
  <span :class="['status-tag', { 'status-tag--pill': pill }]" :style="style">
    <span class="status-tag__dot" :style="{ background: status.dot }"></span>
    <span class="status-tag__label">{{ status.label }}</span>
  </span>
</template>

<script>
import { getStatus } from "@/models/status";

export default {
  name: "StatusTag",
  props: {
    value: { type: Number, default: -1 },
    // Pill draws the tinted background; the bare form is a dot plus label
    // for dense table rows.
    pill: { type: Boolean, default: false },
  },
  computed: {
    status() {
      return getStatus(this.value);
    },
    style() {
      if (!this.pill) return {};
      return {
        background: this.status.tint,
        borderColor: this.status.border,
        color: this.status.text,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.status-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-sm);
  line-height: 1.2;
  white-space: nowrap;

  &--pill {
    padding: 4px 11px;
    border: 1px solid transparent;
    border-radius: 999px;
    font-weight: 500;
  }

  &__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
  }
}
</style>
